import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});
const SET_QUESTIONS = 'SET_QUESTIONS';
const SET_QUESTIONS_VALIDATION_ERRORS = 'SET_QUESTIONS_VALIDATION_ERRORS';
const SET_QUESTIONS_LOADING = 'SET_QUESTIONS_LOADING';
const SET_ANSWERS_LOADING = 'SET_ANSWERS_LOADING';

export function checkForUnacceptedContent(text) {
  let urlPattern = '([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?';
  let emailPattern = '([\\w-\\.]+)@((?:[\\w]+\\.)+)([a-zA-Z]{2,4})';
  let phonePattern = '[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}';
  return (
    new RegExp(urlPattern).test(text) ||
    new RegExp(emailPattern).test(text) ||
    new RegExp(phonePattern).test(text)
  );
}


const state = {
  questions: null,
  questionsValidationErrors: null,
  questionsLoading: false,
  answersLoading: false,
};

const getters = {
  questions({ questions }) {
    return questions;
  },
  questionsValidationErrors({ questionsValidationErrors }) {
    return questionsValidationErrors;
  },
  questionsLoading({ questionsLoading }) {
    return questionsLoading;
  },
  answersLoading({ answersLoading }) {
    return answersLoading;
  },
};

const actions = {
  fetchQuestions({ commit }, id) {
    axios.get(`/gbp/get-questions/${id}`)
      .then(({ data }) => {
        commit(SET_QUESTIONS, data.questions);
      }).catch(error => {

      });
  },
  clearQuestions({ commit }) {
    commit(SET_QUESTIONS, null);
  },
  createQuestion({ commit, dispatch }, {selectedLocation, questionText}) {
    return new Promise((resolve, reject) => {
      commit(SET_QUESTIONS_LOADING, true);
      axios.post(`/gbp/create-question/${selectedLocation}`, {
        questionText
      }).then(() => {
        commit(SET_QUESTIONS_LOADING, false);
        dispatch('fetchQuestions', selectedLocation);
        Toast.fire({
          icon: 'success',
          title: `Question added successfully`
        });
        resolve();
      }).catch(({ response }) => {
        commit(SET_QUESTIONS_LOADING, false);
        commit(SET_QUESTIONS_VALIDATION_ERRORS, response.data.errors);
        Toast.fire({
          icon: 'error',
          title: response.data.message
        });
        reject(error);
      });
    });
  },
  deleteQuestion({ dispatch }, { selectedLocation, question }) {
    return new Promise((resolve, reject) => {
      axios.post(`/gbp/delete-question/${selectedLocation}`, {
        question
      }).then(() => {
        dispatch('fetchQuestions', selectedLocation);
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
  createAnswer({ commit, dispatch }, { selectedLocation, question, answerText}) {
    return new Promise((resolve, reject) => {
      commit(SET_ANSWERS_LOADING, true);
      axios.post(`/gbp/create-answer/${selectedLocation}`, {
        question,
        answerText,
      }).then(() => {
        commit(SET_ANSWERS_LOADING, false);
        dispatch('clearQuestions');
        dispatch('fetchQuestions', selectedLocation);
        Toast.fire({
          icon: 'success',
          title: `Answer added successfully`
        });
        resolve();
      }).catch(({ response }) => {
        commit(SET_ANSWERS_LOADING, false);
        commit(SET_QUESTIONS_VALIDATION_ERRORS, response.data.errors);
        Toast.fire({
          icon: 'error',
          title: response.data.message
        });
        reject(error);
      });
    });
  },
  deleteAnswer({ dispatch }, { selectedLocation, question, answer }) {
    return new Promise((resolve, reject) => {
      axios.post(`/gbp/delete-answer/${selectedLocation}`, {
        question,
        answer
      }).then(() => {
        dispatch('fetchQuestions', selectedLocation);
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
};

const mutations = {
  [SET_QUESTIONS](state, questions) {
    state.questions = questions;
  },
  [SET_QUESTIONS_VALIDATION_ERRORS](state, errors) {
    state.questionsValidationErrors = errors;
  },
  [SET_QUESTIONS_LOADING](state, bool){
    state.questionsLoading = bool;
  },
  [SET_ANSWERS_LOADING](state, bool){
    state.answersLoading = bool;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
